var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("cargo-advance-select", {
    attrs: {
      disabled: _vm.disabled,
      "select-type": _vm.selectTypeNames.static_data_Company,
      "method-params": _vm.methodParams,
      cache: false,
      filterable: "",
      "options-width": "100%",
      "callback-params": _vm.callbackParams,
      "static-options": _vm.staticOptions,
      placeholder: _vm.placeholder,
      headers: _vm.headers && _vm.headers.length > 0 ? _vm.headers : undefined,
      fields: _vm.fields && _vm.fields.length > 0 ? _vm.fields : undefined,
      "tag-name": _vm.tagName,
      multiple: true,
      "default-multiple-value":
        _vm.defaultValue instanceof Array ? _vm.defaultValue : []
    },
    on: { enter: _vm.enter, parentCallBack: _vm.parentCallBack }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }